import { render, staticRenderFns } from "./PerfPerCategory2.vue?vue&type=template&id=2fa0796e&scoped=true&"
import script from "./PerfPerCategory2.vue?vue&type=script&lang=js&"
export * from "./PerfPerCategory2.vue?vue&type=script&lang=js&"
import style0 from "./PerfPerCategory2.vue?vue&type=style&index=0&id=2fa0796e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa0796e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
